export enum PhaserStatuses {
  UNLOADED = 'UNLOADED',
  LOADED = 'LOADED',
}

export interface PhaserState {
  gameStatus: PhaserStatuses,
  regionStatus: PhaserStatuses,
}
